module.exports = __webpack_public_path__ + "static/asha-hero-small-b50070159684a242a73d5c0b5fbcf64d.jpg";